export default __webpack_public_path__ + "static/media/defaultImage.c55259f6.png";